import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=47561dec&scoped=true&"
import script from "./Profile.vue?vue&type=script&setup=true&lang=js&"
export * from "./Profile.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47561dec",
  null
  
)

export default component.exports